import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import BDServiceCard from "@/pages/services/business-development/BDServiceCard";

const COMPANY_NAME = "NetBasis International";

const bdTitle = "Desarrollo de negocio";
const bdHeroOverlay = "¡Siempre con su negocio en mente!";
const bdHeroAlt = "Un empresario planifica estrategias y canales de venta TIC para entrar en el mercado DACH.";
const bdH1 = "Su socio estratégico y operativo para una entrada exitosa en el mercado de la región DACH. Desarrollamos estrategias de mercado pragmáticas para empresas extranjeras del sector de las TIC y las implementamos con éxito a su lado sobre el terreno.";
const bdIntro = "NetBasis International apoya la totalidad de los proyectos comerciales de sus socios fabricantes, ya sea en la introducción de productos, soluciones y servicios existentes en nuevos mercados internacionales o en el desarrollo de nuevas áreas de negocio y oportunidades de mercado. Generamos y desarrollamos estrategias comerciales prácticas y efectivas, creamos y entregamos los planes de implementación requeridos, y acompañamos a nuestros socios durante toda la fase de ejecución y, si lo desean, más allá.";
const benefitsTitle = "Cómo se beneficia de nuestra experiencia en __desarrollo de negocio__:";
const readMore = "Más información";
const bottomClaim = "NetBasis International – drive to excellence with excellent drivers !";

const services = [
  {
    name: "Presencia empresarial",
    image: "https://net-basis.net/Bilder/duesseldorf-media-harbor-rhine-tower-business-location.webp",
    description: "Presencia y contacto local: establezca una base fiable en Düsseldorf y opere en el mercado DACH de forma eficiente, sin los costes de estructuras administrativas propias.",
    to: "/es/servicios/desarrollo-de-negocio/presencia-empresarial",
  },
  {
    name: "Paquete de servicio completo",
    image: "https://net-basis.net/Bilder/ict-full-service-business-development-management.webp",
    description: "Su extensión local en la región DACH: gestionamos todo su negocio de la A a la Z. Mantenga su mente libre para concentrarse en su mercado local.",
    to: "/es/servicios/desarrollo-de-negocio/paquete-de-servicio-completo",
  },
  {
    name: "Consultoría",
    image: "https://net-basis.net/Bilder/ict-market-entry-business-strategy-consulting.webp",
    description: "Consultoría estratégica: evaluamos su potencial en el mercado DACH y le guiamos con asesoramiento a medida desde el análisis inicial hasta el éxito.",
    to: "/es/servicios/desarrollo-de-negocio/consultoria",
  },
  {
    name: "Gestión de productos",
    image: "https://net-basis.net/Bilder/ict-product-management-market-adaptation-modular-development.webp",
    description: "Éxito en el mercado DACH: adaptamos sus productos TIC de forma precisa a las normas y normativas locales.",
    to: "/es/servicios/desarrollo-de-negocio/gestion-de-productos",
  },
  {
    name: "Gestión de proyectos",
    image: "https://net-basis.net/Bilder/project-management-planning-control-dach-market-entry.webp",
    description: "Gestión de proyectos eficaz: controlamos sus proyectos en la región DACH cumpliendo plazos, riesgos y presupuestos.",
    to: "/es/servicios/desarrollo-de-negocio/gestion-de-proyectos",
  },
  {
    name: "Análisis de mercado",
    image: "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp",
    description: "Datos de mercado precisos: analizamos el tamaño del mercado, las tendencias y la competencia local establecida.",
    to: "/es/servicios/desarrollo-de-negocio/analisis-de-mercado",
  },
  {
    name: "Estrategias de entrada al mercado",
    image: "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp",
    description: "Expansión estratégica: diseñamos sus opciones de entrada y planificamos su éxito sostenible en el mercado DACH.",
    to: "/es/servicios/desarrollo-de-negocio/estrategias-entrada-mercado",
  },
  {
    name: "Gestión de importaciones",
    image: "https://net-basis.net/Bilder/import-management-customs-clearance-dach-distribution.webp",
    description: "Su departamento de importación local: gestionamos su logística DACH de forma integral, desde la aduana legal hasta la entrega puntual.",
    to: "/es/servicios/desarrollo-de-negocio/gestion-de-importaciones",
  },
  {
    name: "Comercio internacional",
    image: "https://net-basis.net/Bilder/international-trade-dach-local-expertise.webp",
    description: "Comercio internacional seguro: gestionamos sus estructuras de precios, contratos y licencias en la región DACH para garantizar un negocio conforme y rentable.",
    to: "/es/servicios/desarrollo-de-negocio/comercio-internacional",
  },
  {
    name: "Soporte técnico",
    image: "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp",
    description: "Asistencia técnica rápida: ofrecemos soporte TIC cualificado, telemantenimiento fiable y ayuda presencial para sus clientes en la región DACH.",
    to: "/es/servicios/desarrollo-de-negocio/soporte-tecnico",
  },
];

const benefits = [
  "Identificación y desarrollo de canales de distribución óptimos y redes de socios",
  "Concepción de estrategias de marketing y publicidad dirigidas",
  "Recomendaciones fundamentadas para las modificaciones de productos o adaptaciones al mercado necesarias",
  "Iniciación de oportunidades de desarrollo de productos sostenibles",
  "Preparación estructurada de las operaciones comerciales locales y la logística",
  "Planificación precisa para la realización de las estrategias comerciales acordadas",
  "Análisis y evaluación de oportunidades potenciales para transferencias de tecnología, cooperaciones de licencias, joint ventures o fusiones",
];

export default function BusinessDevelopmentEsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Desarrollo de Negocio | NetBasis International"
        description="Desarrollo estratégico del mercado y soporte operativo de ventas para su éxito duradero en la región de habla alemana."
        ogUrl="https://net-basis.net/es/servicios/desarrollo-de-negocio"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/ict-business-development-strategy-dach-market-entry.webp"
                alt={bdHeroAlt}
                title={bdTitle}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
              <div className="absolute inset-0 z-20 flex items-start justify-end md:justify-start pl-10 md:pl-[30%] lg:pl-[15%] pr-6 md:pr-10 pointer-events-none">
                <p
                  className="w-full text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-right mt-2 md:mt-8 lg:mt-12 max-w-[85%] md:max-w-none animate-[bdTextSlide_12s_ease-in-out_infinite]"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  {bdHeroOverlay}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {bdTitle}
            </h2>
            <h1 className="text-foreground-950 font-semibold text-sm md:text-base leading-relaxed mb-4">
              {bdH1}
            </h1>
            <p className="text-foreground-950 leading-relaxed text-sm md:text-base">
              <strong className="text-primary-600">{COMPANY_NAME}</strong>{" "}
              {bdIntro.replace(COMPANY_NAME, "").trim()}
            </p>
          </div>
        </section>

        <section className="py-5 md:py-7 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col gap-3 md:gap-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {services.slice(0, 3).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                {services.slice(3, 7).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {services.slice(7, 10).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {benefitsTitle.split('__').map((part, i) =>
                i % 2 === 1 ? <em key={i} className="mr-[0.15em]">{part}</em> : part
              )}
            </h2>
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}